import React from 'react'

import CasinoDisabledIcon from '../../../images/casino_disabled_icon.svg'
import { useTranslation } from '../../../context/translationProvider'
import { Button } from '../../atoms/button'
import {
  autoWithdrawalOptIn,
  autoWithdrawalOptOut,
} from '../../../adapters/user'
import { toast } from '../../atoms'
import {
  StyledAutoWDConfirmationContent,
  StyledAutoWDConfirmationModal,
  StyledButtonsContainer,
} from './styles'
import { navigate } from 'gatsby'
import { Text } from '../../atoms/text'
import PropTypes from 'prop-types'
import { pushDataLayer } from '../../../utils/pushDataLayer'

const AutoWDConfirmationModal = ({
  casinoBackLink,
  type = 'disable',
  closeModal,
  setAutoWDEnabled,
}) => {
  const { translate } = useTranslation()
  const location =
    type === 'disable'
      ? 'casino restriction pop-up for auto-wd enabled'
      : 'confirmation pop-up for auto-wd activation'

  const handleOptInOut = async () => {
    if (type === 'disable') {
      const { data } = await autoWithdrawalOptOut()
      if (data?.messageCode === 1) {
        toast.success(translate('account.autoWD.confirm.disable.success'))
        setAutoWDEnabled(false)
      } else {
        toast.error(translate('common.unexpectedError'))
      }
      closeModal()
    } else {
      const { data } = await autoWithdrawalOptIn()
      if (data?.messageCode === 1) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        toast.success(translate('account.autoWD.confirm.enable.success'))
        setAutoWDEnabled(true)
      } else {
        toast.error(translate('common.unexpectedError'))
      }
      closeModal()
    }

    const label = type === 'disable' ? 'disabled' : 'enabled'
    pushDataLayer({
      eventName: `auto-withdrawal-${label}`,
      data: {
        location,
      },
    })
  }

  const handleConfirmationCancel = () => {
    pushDataLayer({
      eventName: 'cancel',
      data: {
        location,
      },
    })

    if (type === 'enable') {
      closeModal()
    } else {
      navigate(casinoBackLink)
    }
  }

  return (
    <StyledAutoWDConfirmationModal>
      <StyledAutoWDConfirmationContent>
        <h2>{translate(`account.autoWD.confirm.${type}.title`)}</h2>
        <img src={CasinoDisabledIcon} height={100} />
        <Text textAlign={'center'}>
          {translate(`account.autoWD.confirm.${type}.description`)}
        </Text>
      </StyledAutoWDConfirmationContent>
      <StyledButtonsContainer>
        <Button onClick={handleOptInOut}>
          {translate(`account.autoWD.confirm.${type}.confirmButtonLabel`)}
        </Button>
        <Button bordered dark onClick={handleConfirmationCancel}>
          {translate('common.cancel')}
        </Button>
      </StyledButtonsContainer>
    </StyledAutoWDConfirmationModal>
  )
}

AutoWDConfirmationModal.defaultProps = {
  casinoBackLink: '',
  type: 'disable',
  closeModal: null,
  setAutoWDEnabled: null,
}

AutoWDConfirmationModal.propTypes = {
  casinoBackLink: PropTypes.string,
  type: PropTypes.oneOf(['enable', 'disable']),
  closeModal: PropTypes.func,
  setAutoWDEnabled: PropTypes.func,
}

export { AutoWDConfirmationModal }
